import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs/';
import { Subject } from 'rxjs/Subject';

import { DomainService } from '../../../services/domain.service';
import { AuthService } from '../../../services/auth.service';
import { FullscreenService } from '../../../services/fullscreen.service';
import { SessionService } from '../../../services/session.service';
import { NotificationService } from '../../../services/notification.service';
import { ConfigService } from '../../../services/config.service';
import { BreadcrumbsComponent } from 'app/shared/components/breadcrumbs/breadcrumbs.component';
import { StorageService } from 'app/core/services/storage.service';
import { ProfileService } from '../../profile/profile.service';
import { CacheService } from 'app/core/services/cache.service';
import { of } from 'rxjs/observable/of';

declare var $: any;

@Component({
    selector: 'itpx-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css']
})

export class NavbarComponent implements OnInit, AfterViewInit {
    private isAuth: boolean;
    private userDetails: Object;
    private defaultAvatar: string;
    private imgUrl;
    private domain;

    private isViewingContent: boolean;
    private showBackButton: boolean;
    redirectedLXPUser: boolean;
    hwRedirect = false;
    constructor(
        private domainService: DomainService,
        private authService: AuthService,
        private sessionService: SessionService,
        private storageService: StorageService,
        private notificationService: NotificationService,
        private configService: ConfigService,
        private router: Router,
        private route: ActivatedRoute,
        private fullscreenService: FullscreenService,
        private breadcrumbs: BreadcrumbsComponent,
        private cacheService: CacheService
    ) { }

    ngOnInit() {
        // this.cacheService.getCachedProfile().map(p => p.data).subscribe(res => {
        //     if (res && res.hwRedirect && !res.bpRedirect)
        //         this.goToHW()
        //     if (res && res.hwRedirect)
        //         this.hwRedirect = true;
        // });
        this.imgUrl = this.configService.get('server').images;
        this.domain = this.domainService.getDomain();
        this.defaultAvatar = this.configService.get('links').defaultAvatar;

        if (this.isLXPUser()) {
            this.redirectedLXPUser = true;
        }

        // TODO: bind to lifecycle
        // this.authService.isAuthenticated$
        //     .subscribe(authenticated => {
        //         this.isAuth = authenticated;
        //     });

        // TODO: bind to lifecycle
        this.authService.isAuthenticated$.switchMap(authenticated => {
            this.isAuth = authenticated;
            if (authenticated)
                return this.cacheService.getCachedProfile()
            else
                return of({ data: null })
        })
            .map(p => p.data).subscribe(res => {
                if (res && res.hwRedirect && !res.bpRedirect)
                    this.goToHW()
                if (res && res.hwRedirect)
                    this.hwRedirect = true;
            });

        this.sessionService.user()
            .subscribe(user => {
                this.userDetails = user
            });

        this.router.events
            .filter(e => e instanceof NavigationEnd)
            .map((e: NavigationEnd) => e.url.indexOf('/scorm') > -1)
            .subscribe(val => this.isViewingContent = val);

        this.router.events
            .filter(e => e instanceof NavigationEnd)
            .map((e: NavigationEnd) => e.url.indexOf('/googleslides') > -1 || e.url.indexOf('/video') > -1)
            .subscribe(val => this.showBackButton = val);
    }

    ngAfterViewInit() {
        $(document).on('click.nav', '.navbar-collapse.in', function (e) {
            if ($(e.target).is('a')) {
                $(this).removeClass('in').addClass('collapse');
            }
        });
    }

    private onFullscreenClicked() {
        let mainContainer = document.getElementById('main-c');
        this.fullscreenService.enterFullscreen(mainContainer);
    }
    goToHW() {
        window.location.href = `${window.location.origin}/hw/app/courseware?leapest-force-login=true`;
    }
    login() {
        this.authService.login();
    }

    logout() {
        this.authService.logout();
    }

    onBackClicked() {
        this.breadcrumbs.goBack();
    }

    isLXPUser() {
        const lxpDomains = (this.storageService.get('lxp-domain-list') || '').split(', ');
        return lxpDomains.indexOf(this.domain.name) >= 0;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/components/partials/navbar/navbar.component.ts